import React from 'react';

import './index.scss'

//material-ui
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';

//custom components
import CustomButton from '../../../../../components/basic/CustomButton';

//api
import {api} from '../../../../../functions/api'

//other libraries
import { inject, observer } from 'mobx-react';
import {toJS} from 'mobx';
// import Icon from '@mdi/react'
// import { mdiUpload } from '@mdi/js'
import Dropzone from 'react-dropzone'


@inject('translate')
@inject('internal')
@observer
export default class UploadDocument extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            doc_type: -1,
            selectedFile: null,
            loadingBtn: false,
        }
    }
    handleChange = (event) => {
        this.setState({doc_type: event.target.value})
    }

    handleClickOpenDialog = () => {
        this.refs.fileUploader.click();
    }

    file = null;
    fileChangedHandler = (event) => {
        this.file = event.target.files[0];
        this.setState({selectedFile: event.target.files[0]})
    }

    uploadDocument = async () => {
        this.setState({loadingBtn: true})
        //clients/{client_id}/documents

        let idClient = Number(this.props.routerData.match.params.idClient)
        
        let upload_data = await api({
            method: 'post',
            url: 'clients/'+ idClient +'/documents',
            formData: true,
            formDataDoc: true,
            authorization: this.props.internal.user.access_token,
            params: {
                file: this.state.selectedFile,
                document_type_id: this.state.doc_type
            },

        })

        if(upload_data.success === false && upload_data.status === 201) {
            this.props.showSnackbar(upload_data.data.message, true, false)
        }
        else if(upload_data.success === false && upload_data.data.error) {
            let resultError = "";
            for(let error in upload_data.data.data.errors)
            {
                resultError += upload_data.data.data.errors[error] + " "
            }
            this.props.showSnackbar(resultError, true, true)
        }
        this.setState({loadingBtn: false})
    }

    handleDrop = (files) => {
        if(files[0] !== undefined) {
            this.setState({
                selectedFile: files[0],
            })
            
        }
        else {
            this.props.internal.setSnackbar(this.props.translate.i18n.GLOBAL.ALERTS.FORMAT_IS_NOT_VALID, true)
        }
        
    }

    render() {
        return(
            <Dialog
                open={this.props.open}
                onClose={this.props.onClose}
                aria-labelledby="form-dialog-title"
                
            >
                <DialogTitle id="form-dialog-title">{this.props.translate.i18n.MODULES.CLIENTS.UPLOAD_DOC}</DialogTitle>
                <DialogContent className={'upload-doc-dialog'}>
                    <FormControl className={'doc-type-select'}>
                        <InputLabel htmlFor="doc-type">Typ dokumentu</InputLabel>
                        <Select
                            className={'w-100 '}
                            value={this.state.doc_type !== -1 ? this.state.doc_type : ""}
                            onChange={this.handleChange}
                            inputProps={{
                                name: 'doc-type',
                                id: 'doc-type',
                            }}
                        >
                            {/* <MenuItem value=""><em>Zvolte si typ dokumentu</em></MenuItem> */}
                            {toJS(this.props.internal.dataForTable.lists.document_types).map((type, index) => {
                                let tmpDataTitle = (type.title).toUpperCase()
                                return (
                                    <MenuItem key={type.id} value={type.id}>{this.props.translate.i18n.GLOBAL.DOC_TYPES[tmpDataTitle]}</MenuItem>
                                )
                            })}
                        </Select>
                    </FormControl>
                    {/* <div className={'upload-btn'}>
                    {this.state.selectedFile ? <p className={'choosen-file-name'}>{this.state.selectedFile.name}</p> : null }
                    <CustomButton
                        mystyle = {'btn-orange-bg border-radius-18'}
                        title = "Nahrať dokument"
                        onClick={this.handleClickOpenDialog}
                    >
                        <Icon
                            path = { mdiUpload}
                            size = {1}
                        />
                    </CustomButton>
                    <input
                        className={'image_upload'}
                        ref={'fileUploader'}
                        type="file"
                        onChange={this.fileChangedHandler}
                        multiple
                    />
                </div> */}
                <Dropzone
                    onDrop={files => this.handleDrop(files)}
                    // disableClick
                    multiple={false}
                    // accept={[".xlsx", ".xls"]}
                    >
                    {({getRootProps, getInputProps, open}) => (
                        <div {...getRootProps()} className={`dropzone ${this.state.selectedFile !== null ? "dropped":""}`}>
                        <input {...getInputProps()} />
                            {this.state.selectedFile !== null && this.state.selectedFile.name?
                                <p>{this.state.selectedFile.name}</p>
                                :
                                <p>{this.props.translate.i18n.MODULES.CLIENTS.IMPORT_PLACE}</p>
                            }
                            

                            {/* <button type="button" onClick={() => open()}>
                            {this.props.translate.i18n.MODULES.CLIENTS.IMPORT_CLIENTS_BUTTON}
                            </button> */}
                        </div>
                    )}
                </Dropzone>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.props.onClose} className={'gray-text'}>
                    {this.props.translate.i18n.GLOBAL.BUTTONS.CANCEL}
                    </Button>
                    {/* <Button onClick={this.uploadDocument} className={'orange-text'}>
                    {this.props.translate.i18n.GLOBAL.BUTTONS.SAVE}
                    </Button> */}
                    <CustomButton
                        justText
                            progressBar={this.state.loadingBtn}
                            onClick={this.uploadDocument}
                            mystyle={'btn-white-bg width-80'}
                            title={this.props.translate.i18n.GLOBAL.BUTTONS.SAVE}
                        />
                </DialogActions>
                
            </Dialog>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/clients/detail/docs/add/index.js